import { getCurrentCountry } from './country';

function resolveBelgiumCulture(pathname: string): string {
  const pathnameInLowerCase = pathname.toLowerCase();
  if (
    pathnameInLowerCase.startsWith('/fr') ||
    pathnameInLowerCase.startsWith('/fr-be')
  ) {
    return 'fr-BE';
  }
  return 'nl-BE';
}

function resolveAmericanCulture(pathname: string): string {
  const pathnameInLowerCase = pathname.toLowerCase();
  if (
    pathnameInLowerCase.startsWith('/es') ||
    pathnameInLowerCase.startsWith('/us/es') // support for vista.com
  ) {
    return 'es-US';
  }
  return 'en-US';
}

function resolveCanadianCulture(pathname: string): string {
  const pathnameInLowerCase = pathname.toLowerCase();

  if (
    pathnameInLowerCase.startsWith('/fr') ||
    pathnameInLowerCase.startsWith('/ca/fr') // support for vista.com
  ) {
    return 'fr-CA';
  }
  return 'en-CA';
}

function resolveSwissCulture(pathname: string): string {
  const pathnameInLowerCase = pathname.toLowerCase();
  if (pathnameInLowerCase.startsWith('/fr')) {
    return 'fr-CH';
  }
  if (pathnameInLowerCase.startsWith('/it')) {
    return 'it-CH';
  }
  return 'de-CH';
}

export const getCurrentCulture = (host: string, path: string) => {
  const country: string = getCurrentCountry(host, path);

  switch (country.toUpperCase()) {
    case 'PT':
      return 'pt-PT';
    case 'IE':
      return 'en-IE';
    case 'ES':
      return 'es-ES';
    case 'IN':
      return 'en-IN';
    case 'US':
      return resolveAmericanCulture(path);
    case 'GB':
      return 'en-GB';
    case 'FR':
      return 'fr-FR';
    case 'IT':
      return 'it-IT';
    case 'DE':
      return 'de-DE';
    case 'NL':
      return 'nl-NL';
    case 'DK':
      return 'da-DK';
    case 'SE':
      return 'sv-SE';
    case 'AT':
      return 'de-AT';
    case 'NO':
      return 'nb-NO';
    case 'FI':
      return 'fi-FI';
    case 'BE':
      return resolveBelgiumCulture(path);
    case 'SG':
      return 'en-SG';
    case 'JP':
      return 'ja-JP';
    case 'NZ':
      return 'en-NZ';
    case 'AU':
      return 'en-AU';
    case 'CA':
      return resolveCanadianCulture(path);
    case 'CH':
      return resolveSwissCulture(path);
  }

  throw new Error(`Unknown culture for host ${host} and path ${path}`);
};
